import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, Fragment as _Fragment } from "vue";
import _imports_0 from '@/assets/icons/arrows/ico-ico-zezarizeni.svg';
import _imports_1 from '@/assets/icons/arrows/ico-ico-dozarizeni.svg';
const _hoisted_1 = {
    class: "position-relative w-100",
    style: { "min-height": "550px" }
};
const _hoisted_2 = { class: "gray-text-light" };
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = { key: 0 };
const _hoisted_5 = { key: 1 };
const _hoisted_6 = {
    key: 0,
    class: "atom-tag atom-tag--muted"
};
const _hoisted_7 = {
    key: 1,
    class: "atom-tag atom-tag--success"
};
const _hoisted_8 = {
    key: 2,
    class: "atom-tag atom-tag--success"
};
const _hoisted_9 = {
    key: 3,
    class: "atom-tag atom-tag--warning"
};
const _hoisted_10 = ["onClick"];
import CopyNotification from "@/components/notify/notify.vue";
import MessageFilter from "@/components/filters/message-table-filter.vue";
import { onMounted, ref, watch } from "vue";
import { client } from "@/main";
import TableV2 from "@/components/custom-table/TableV2.vue";
import UdpMessageDetail from "@/components/devices/udp/udpMessageDetail.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'messagesTab',
    props: {
        device: {}
    },
    setup(__props) {
        const props = __props;
        const copyConfirmationVisible = ref(false);
        const from = ref(new Date());
        const to = ref(new Date());
        const page = ref(0);
        const pageSize = ref(20);
        watch(() => from.value, () => {
            loadMessages();
        });
        watch(() => to.value, () => {
            loadMessages();
        });
        const messageList = ref([]);
        const isLoading = ref(false);
        const selectedMessage = ref(null);
        onMounted(() => {
            resetSearch();
            loadMessages();
        });
        async function loadUpMessages() {
            let upMessageList = [];
            async function performRequest(offset = 0) {
                const { data: result } = await client.path("/udp/devices/{id}/up/messages").method("get").create()({
                    id: props.device.deviceId,
                    limit: 1000,
                    from: from.value.toISOString(),
                    to: to.value.toISOString(),
                    offset
                });
                return result;
            }
            const result = await performRequest();
            upMessageList = result.data;
            for (let i = 1000; i < result.metadata.count; i += 1000) {
                const result = await performRequest(i);
                upMessageList = upMessageList.concat(result.data);
            }
            upMessageList = upMessageList.map((message) => ({
                ...message,
                type: "up",
                state: message.messageStatus === "preregistration" ? "TEST" : "OK"
            }));
            return upMessageList;
        }
        const loadMessages = async () => {
            if (isLoading.value) {
                return;
            }
            isLoading.value = true;
            messageList.value = await loadUpMessages();
            messageList.value = messageList.value.map((message) => ({
                ...message,
                custDeviceName: props.device.name
            }));
            messageList.value = messageList.value.sort((b, a) => new Date(a.messageTime).getTime() - new Date(b.messageTime).getTime());
            isLoading.value = false;
        };
        function resetSearch() {
            const now = new Date();
            const yesterday = new Date(now - 24 * 60 * 60 * 1000);
            yesterday.setHours(0, 0, 0, 0);
            now.setHours(23, 59, 59, 999);
            from.value = yesterday;
            to.value = now;
        }
        const tableColumns = [
            {
                name: "custDeviceName",
                title: "device",
                sortable: false,
                visible: true,
                minWidth: "250px",
                order: 1
            },
            {
                name: "messageTime",
                sortable: true,
                visible: true,
                minWidth: "180px",
                order: 2
            },
            {
                name: "type",
                sortable: false,
                visible: true,
                minWidth: "120px",
                order: 3
            },
            {
                name: "state",
                sortable: false,
                visible: true,
                minWidth: "70px",
                order: 4
            },
            {
                name: "Data",
                sortable: false,
                visible: true,
                minWidth: "300px",
                order: 5
            }
        ];
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(CopyNotification, {
                    opened: copyConfirmationVisible.value,
                    text: 'zkopirovanoDoSchranky',
                    onClose: _cache[0] || (_cache[0] = ($event) => (copyConfirmationVisible.value = false))
                }, null, 8, ["opened"]),
                _createVNode(MessageFilter, {
                    "hide-suspended-state": "",
                    "no-type": "",
                    "no-status": "",
                    from: from.value.toISOString(),
                    to: to.value.toISOString(),
                    rows: messageList.value,
                    all: messageList.value,
                    count: messageList.value.length,
                    "fulltext-disabled": true,
                    onFilteredItems: _cache[1] || (_cache[1] = ($event) => (messageList.value = $event)),
                    onSetTo: _cache[2] || (_cache[2] = ($event) => (to.value = new Date(new Date($event).setHours(23, 59, 59, 999)))),
                    onResetSearch: resetSearch,
                    onSetFrom: _cache[3] || (_cache[3] = ($event) => (from.value = new Date(new Date($event).setHours(0, 0, 0, 0)))),
                    onResetPaging: _cache[4] || (_cache[4] = ($event) => (page.value = 0))
                }, null, 8, ["from", "to", "rows", "all", "count"]),
                _createElementVNode("div", _hoisted_1, [
                    _createVNode(TableV2, {
                        columns: tableColumns,
                        items: messageList.value,
                        "items-total-count": messageList.value.length,
                        "default-sorting-index": 1,
                        "default-sort-type": "desc",
                        "empty-text": "zadneZpravyKZobrazeni",
                        "table-id": "udpMessages",
                        "item-id": "id",
                        "actions-width": "75px",
                        onPageChange: _cache[5] || (_cache[5] = ($event) => (page.value = $event)),
                        onPageSizeChange: _cache[6] || (_cache[6] = ($event) => (pageSize.value = parseInt($event)))
                    }, {
                        custDeviceName: _withCtx(({ item }) => [
                            _createElementVNode("span", _hoisted_2, _toDisplayString(item.custDeviceName), 1)
                        ]),
                        messageTime: _withCtx(({ item }) => [
                            _createElementVNode("span", {
                                innerHTML: _ctx.$filters.dateTime(item.messageTime)
                            }, null, 8, _hoisted_3)
                        ]),
                        type: _withCtx(({ item }) => [
                            _createElementVNode("span", null, [
                                (item.type == 'up')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                                        _cache[8] || (_cache[8] = _createElementVNode("img", {
                                            src: _imports_0,
                                            class: "mr-2"
                                        }, null, -1)),
                                        _createTextVNode(" " + _toDisplayString(_ctx.$t("zeZarizeni")), 1)
                                    ]))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_5, [
                                        _cache[9] || (_cache[9] = _createElementVNode("img", {
                                            src: _imports_1,
                                            class: "mr-2"
                                        }, null, -1)),
                                        _createTextVNode(" " + _toDisplayString(_ctx.$t("doZarizeni")), 1)
                                    ]))
                            ])
                        ]),
                        state: _withCtx(({ item }) => [
                            (item.messageStatus == 'suspended')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.$t("MSG_SUSPENDED")), 1))
                                : (item.state == 'OK')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, "OK"))
                                    : (item.state == 'TEST')
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_8, "TEST"))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_9, "?"))
                        ]),
                        Data: _withCtx(({ item }) => [
                            _createTextVNode(_toDisplayString(item.message.data), 1)
                        ]),
                        actions: _withCtx(({ item }) => [
                            _createElementVNode("span", {
                                class: "link",
                                onClick: ($event) => (selectedMessage.value = item)
                            }, _toDisplayString(_ctx.$t("zobrazit")), 9, _hoisted_10)
                        ]),
                        _: 1
                    }, 8, ["items", "items-total-count"])
                ]),
                _createVNode(UdpMessageDetail, {
                    "is-open": !!selectedMessage.value,
                    message: selectedMessage.value,
                    device: _ctx.device,
                    onClose: _cache[7] || (_cache[7] = ($event) => (selectedMessage.value = null))
                }, null, 8, ["is-open", "message", "device"])
            ], 64));
        };
    }
});
